/**
 * @file user
 * @Author ytyjm
 * @Create 10:33 2020/5/11
 * @Version 1.0
 * @Description:
 */
import {getActStatus, getCoinInfo} from "@/services/api";

// import {getHealthCodeForH5, saveRealName} from "@/services/api";
// import AES from "@/libs/AES";

export default {
    state: {
        token: '',
        deviceCoding: '',
        phone: '',
        userId:'',
        walletStatus: false,
        pageStatus: '',
        coinNum: 0,// 能量数
        inviteNum: 0,
        totalCoinNum: '',
        name: '',
        certNo: '',
        isHaveHealthCode: ''//是否有健康码：true，有；false，无
    },
    mutations: {
        setToken(state, token) {
            state.token = token
        },
        setDeviceCoding(state, deviceCoding) {
            state.deviceCoding = deviceCoding
        },
        setPhone(state, userId) {
            state.userId = userId
        },
        setUserId(state, phone) {
            state.phone = phone
        },
        setWalletStatus(state, walletStatus) {
            state.walletStatus = walletStatus
        },
        setPageStatus(state, pageStatus) {
            state.pageStatus = pageStatus
        },
        setCoinNum(state, coinNum) {
            state.coinNum = coinNum
        },
        setInviteNum(state, inviteNum) {
            state.inviteNum = inviteNum
        },
        setTotalCoinNum(state, totalCoinNum) {
            state.totalCoinNum = totalCoinNum
        }
    },
    actions: {
        handGetWalletStatus({commit}, {token, deviceCoding}) {
            /*   if (token) commit('setToken', token)
               if (deviceCoding) commit('setDeviceCoding', deviceCoding)*/
            return new Promise((resolve, reject) => {
                try {
                    let robj = new FormData();
                    robj.append('token', token)
                    robj.append('deviceCoding', deviceCoding)
                    getActStatus(robj).then(res => {
                        if (res.respcod === '01') {

                            commit('setWalletStatus', !(res.data === '00'))
                            resolve(res.data)
                        } else {
                            reject(res.respmsg)

                        }
                    }).catch(onerror => {
                        console.log(onerror)
                        reject('网络错误');
                    })
                } catch (e) {
                    reject('运行错误');
                }
            })
        },

        handLocalSaveLoginInfo({commit}, {token, deviceCoding, phone}) {
            return new Promise((resolve, reject) => {
                try {
                    if (token) commit('setToken', token)
                    if (deviceCoding) commit('setDeviceCoding', deviceCoding)
                    if (phone) commit('setPhone', phone)
                    resolve('注册成功')
                } catch (e) {
                    reject('运行错误');
                }
            })
        },
        handGetUserCoinInfo({commit}, {token, deviceCoding}) {
            /*   if (token) commit('setToken', token)
               if (deviceCoding) commit('setDeviceCoding', deviceCoding)*/
            return new Promise((resolve, reject) => {
                try {
                    let robj = new FormData();
                    robj.append('token', token)
                    robj.append('deviceCoding', deviceCoding)
                    getCoinInfo(robj).then(res => {
                        if (res.respcod === '01') {

                            commit('setCoinNum', res.data.coinNum)
                            commit('setInviteNum', res.data.inviteNum)
                            commit('setTotalCoinNum', res.data.totalCoinNum)
                            resolve(res.data)
                        } else {
                            if (res.respmsg === '请先登录') {
                                commit('setToken', '')
                                commit('setDeviceCoding', '')
                                commit('setPhone', '')
                            }
                            reject(res.respmsg)

                        }
                    }).catch(onerror => {
                        console.log(onerror)
                        reject('网络错误');
                    })
                } catch (e) {
                    reject('运行错误');
                }
            })
        },
    }
}
